import en from './en.js'
import zh from './zh.js';
import jp from './jp.js';
import kr from './kr.js';

const langMap = [
  { main: en, code: 'en', label: 'English' },
  { main: jp, code: 'jp', label: '日本語' },
  { main: kr, code: 'kr', label: '한국어' },
  { main: zh, code: 'zh', label: '中文' },
]

const localStoragekey = 'assuar_lang_key';

export const setLocalLangCode = (langCode) => {
  if(!langCode) return;

  window.localStorage.setItem(localStoragekey, langCode);
}

export const getLocalLangCode = () => {
  return window.localStorage.getItem(localStoragekey) || 'en';
}

export const getLangList = () => {
  return langMap.map(l => ({ code: l?.code, value: l?.code, label: l?.label }));
}

export const getLocalLang = () => {
  const langCode = getLocalLangCode();
  const [ target = null ] = langMap.filter(l => l?.code == langCode)
  return target;
}

export const LOCAL = (key) => {
  if(!key) return '';

  const langCode = getLocalLangCode() || 'en';
  const [ target = null ] = langMap.filter(l => l?.code == langCode)
  const value = target && target?.main[key] || '';
  return typeof value === 'function' ? value() : value;
}